export function assertUnreachable(_x: never): never {
    throw new Error(`${_x} Didn't expect to get here, one or more case in switch statement is missing`);
}
